import { render, staticRenderFns } from "./CollectionDetailModal.vue?vue&type=template&id=9de43082&"
import script from "./CollectionDetailModal.vue?vue&type=script&lang=js&"
export * from "./CollectionDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports